/**
 * Usage:
 *
 * dispatch('alert/createAlert', { data: error.response.data }, { root: true })
 *
 */
const state = {
  data: null,
  detail: null,
  status: null, // enum: 'success', 'warning', 'error'
  type: 'toast'
};

const getters = {
  getStatus: (state) => {
    return state.status;
  },
  getData: (state) => state.data,
  getDetail: (state) => state.detail,
  getType: (state) => state.type,
};

const mutations = {
  setData: (state, payload) => (state.data = payload),
  setDetail: (state, payload) => (state.detail = payload),
  setType: (state, payload) => (state.type = payload),
  setStatus: (state, payload) => (state.status = payload),
};

const actions = {
  async createAlert({ commit }, { data, status, detail, type = 'toast', timeout = 5000, autoClose = true }) {
    commit('setData', data);
    commit('setStatus', status);
    commit('setDetail', detail);
    commit('setType', type ?? 'toast')
    // type ? commit("setType", type) : null;
    if (autoClose) {
      setTimeout(() => {
        commit('setData', false);
      }, timeout);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
